import { 
    SOP_CDN_PATH,
    USER_MANUAL_CONTRIBUTOR_CDN_PATH,
    GIGW_Web_Accessibility
} from '../components/Constants';
import { useEffect } from 'react';
import { useRef } from 'react';
import { Link } from "react-router-dom";
import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
export const TaskItem = ({ task, IMAGE_PATH, searchQuery }) => {
    
    //new Code for useNavigate
    // const navigate = useNavigate();

    const dropdownRef = useRef(null);  
    const  [dropDown, setDropDown] = useState(false)

    const toggleDropDown = () =>{
        setDropDown((prev) => !prev);  
    }
    // for description
    const [isExpanded, setIsExpanded] = useState(false);

    const labelMapping = {
        All: "All",
        Low: "Beginner",
        Medium: "Intermediate",
        High: "Advanced",
      };

    const ComplexityCssMapping  = {
        All:"all",
        Low: "beginer",
        Medium: "intermediate",
        High: "advance",

    }

    const StatusCssMapping  = {
        Active:"beginer",
        Archived: "intermediate",
    }

    //To close dropdown if clicked anywhere on screen
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current  && !dropdownRef.current.contains(event.target) ) {
                setDropDown(false);  // Close dropdown if click is outside
            }
        };
        if (dropDown) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [dropDown]);

    const colors = ['#64bfa4', '#74bbfb', '#95e3c0', '#9ab8c2', '#a58d7f', '#aefd6c'];

    function getRandomColor() {
        const randomIndex = Math.floor(Math.random() * colors.length);
        return colors[randomIndex];
      }
    
    const handleImageClick = () => {
        window.open(SOP_CDN_PATH, '_blank');
    };

    const handleUserClick = () => {
        window.open(USER_MANUAL_CONTRIBUTOR_CDN_PATH, '_blank');
    };

    const handleExcelClick = () =>{
        const link = document.createElement('a');
        link.href = GIGW_Web_Accessibility;
        link.download = ''; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const allowedArtifactIds = [500795, 500619, 496888];

     // Function to highlight text
    const highlightText = (task, search) => { 
        if((search !== undefined) && (search !== '')){
            const regex = new RegExp(`(${search})`, 'gi');
            const parts = task.split(regex);
        return parts.map((part, index) =>
            part.toLowerCase() === search.toLowerCase() ? <span key={index} style={{ backgroundColor: 'yellow' }}>{part}</span> : part
        );
        } else {
            // If searchQuery is undefined or empty, return the task text as it is
            return task;
        }
    };

    const baseUrl = `${window.location.origin}/collabwithgov`;
    const fullUrl = `${baseUrl}/detail/${task.artifact_id}`;
    // const fullUrl = 'https://openforge.gov.in/collabwithgov/detail/304076';
    const [isCopied, setIsCopied] = useState(false);
    const copyToClipboard = () => {
        navigator.clipboard.writeText(fullUrl)
            .then(() => {
                setIsCopied(true); // Set copied state to true
                setTimeout(() => setIsCopied(false), 2000); // Reset after 2 seconds
            })
            .catch(err => {
                console.error('Failed to copy: ', err);
            });
    };
    const handleFacebookShare = () => {
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fullUrl)}`;
        window.open(facebookUrl, '_blank', 'width=600,height=400');
    };

    // Handle WhatsApp share
    const handleWhatsAppShare = () => {
        const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(fullUrl)}`;
        window.open(whatsappUrl, '_blank');
    };
    //new Code useNavigate
    // const handleNavigation  = () =>{
    //     navigate(`/collabwithgov/detail/${task.artifact_id}`, { state: { task } });
    // }
    // Handle Email share
    const handleEmailShare = () => {
        const subject = 'Check this out!';
        const body = `I wanted to share this with you: ${fullUrl}`;
        const emailUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = emailUrl;
    };

    // Handle Twitter share
    const handleTwitterShare = () => {
        const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(fullUrl)}`;
        window.open(twitterUrl, '_blank', 'width=600,height=400');
    };

    // Handle LinkedIn share
    const handleLinkedInShare = () => {
        const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(fullUrl)}`;
        window.open(linkedInUrl, '_blank', 'width=600,height=400');
    };
      

    let submittedDateFormatted = '';
    let differenceInDays = '';
    if (task && task.hasOwnProperty('last_submission_date_1')) {
        let Last_Submission_Date = task?.last_submission_date_1?.value?.[0];
        let submittedDate = new Date(Last_Submission_Date);

        // Extract day, month (in short form and uppercase), and year
        let day = submittedDate.getDate();
        let month = submittedDate.toLocaleString('en-US', { month: 'short' }).toUpperCase();
        let year = submittedDate.getFullYear();

        // Format the date as "DD MON YYYY"
        submittedDateFormatted = `${day} ${month} ${year}`;

        // Get the current date
        let currentDate = new Date();

        let submission_on = new Date(task.submitted_on * 1000);

        // Calculate the difference in time (in milliseconds)
        let differenceInTime = currentDate - submission_on;

        // Convert the difference in time to days
        differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));

        // If differenceInDays is negative, set it to 0
        differenceInDays = differenceInDays < 0 ? 0 : differenceInDays;
    }

    

    return (
        <>
           
            <div className="row" id="update_list">
                <div className="col-sm-12">
                    <div className="card">
                        {/* Header Section */}
                        <div className="bg-white card-header d-flex flex-column flex-md-row align-items-start align-items-md-center bg-w border-0 gap1">
                            
                        <div>
                            {
                            (task.hasOwnProperty('category') && (task.category.value) && (task.category.value.length > 0))?task.category.value.map((category, idx) => (
                                <span className="badge bg-light " key={`category-${idx}`}><img src={`${IMAGE_PATH}/design_services.png`} alt="design_services.png"></img>{category}</span>
                            )):''
                            } 
                             
                            </div>
                            {/* <div id="mb_clock1"><img src={`${IMAGE_PATH}/mb_clock_1.png`}/> {differenceInDays} day(s) left</div> */}
                            {
                                (task.hasOwnProperty('complexity') && (task.complexity.value) && (task.complexity.value.length > 0))?task.complexity.value.map((level, idx) => (
                                    <span className={`badge badge-${ComplexityCssMapping[level?.trim()]} mt-2 complexity_level  `} key={`level-${idx}`}  style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100px'}}>{labelMapping[level?.trim()]}</span>
                                )):''
                            }
                            {
                                <span className={`badge badge-${StatusCssMapping[task?.status ? task.status.trim():'']} ms-md-2 btn-ux`} style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100px'}}>                    
                                    {task?.status ? task.status : null}
                                </span>
                            }
                        
                             

                        </div>
                        <div className="col-sm-12 contnt-main" style={{marginTop: '-20px' }}>
                                <small className="right-aligned pstd-date" style={{color:'#4F4F4F'}}>Posted {differenceInDays} days ago</small>
                            </div>
                        <div>
                            
                            {/* <a className="text-decoration-none">
                            <i className="bi bi-share"></i>
                            </a> */}
                        </div>

                        {/* Body Section */}
                        <div className="card-body">
                        <h3>{
                                (task.hasOwnProperty('title') && (task.title.value) && (task.title.value.length > 0))?task.title.value.map((title, idx) => (
                                    <div key={`title-${idx}`}>
                                        <img src={`${IMAGE_PATH}/share.png`}className="share-icon"style={{ float: 'right', marginRight: '10px' , cursor: 'pointer'}} alt="share.png" data-bs-toggle="modal" data-bs-target={`#${task.artifact_id}`}/>
                                        <h2 style={{fontSize:'1.25rem', textAlign:'left'}} className="campaign_hd mb-1" key={idx}>{highlightText(title, searchQuery)}{' '}
                                        {task.hasOwnProperty('mode_of_the__task_1') && task.mode_of_the__task_1.value && task.mode_of_the__task_1.value[0] !== null && (
                                            <span className="campaign_label">
                                                <img src={`${IMAGE_PATH}/campaign_1.png`} alt="Campaign" /> Campaign
                                            </span>
                                        )}
                                        </h2>
                                    </div>
                                )):''
                                }   </h3>
                             
                            <div className="modal fade" id={task.artifact_id} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                 
                                    <div className="modal-body p-0">
                                   
                                              <div className="pop_box1">
                                                <h4><img src={`${IMAGE_PATH}/Group_share.png`} alt="group share" /> Share This Task</h4><hr/>
                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                <ul className="list-group list-group-horizontal">
                                                    <li className="list-group-item border-0"><img src={`${IMAGE_PATH}/Group_whatsapp.png`} alt="whatsapp" onClick={handleWhatsAppShare}/></li>
                                                    <li className="list-group-item border-0"><img src={`${IMAGE_PATH}/Group_email.png`} alt="email" onClick={handleEmailShare}/></li>
                                                    <li className="list-group-item border-0"><a href="https://twitter.com/openforge_ind" target="_blank" rel="noreferrer"><img src={`${IMAGE_PATH}/Group_x.png`} alt="twitter" onClick={handleTwitterShare}/></a></li>
                                                    <li className="list-group-item border-0"><a href="https://www.facebook.com/share_channel/" target="_blank" rel="noreferrer"><img src={`${IMAGE_PATH}/Group_facebook.png`} alt="facebook" onClick={handleFacebookShare}/></a></li>
                                                    <li className="list-group-item border-0"><img src={`${IMAGE_PATH}/Group_linkedin.png`} alt="linkedin" onClick={handleLinkedInShare}/></li>
                                                </ul>
                                              </div>
                                              <div className="pop_box2">
                                                 <h5>Copy Link</h5>
                                                <div className="input-group mb-3">
                                                
                                                <input type="text" className="form-control" aria-label="collaboratewithgovernment/Chandigarhtourismwebsiteuxaudit" value={fullUrl} readOnly/>
                                                <span className={`input-group-text text-copy ${isCopied ? 'text-success' : ''}`} onClick={copyToClipboard}>{isCopied ? 'Link Copied' : <img src={`${IMAGE_PATH}/content_copy.png`} alt="copy" />}</span>
                                                </div>
                                              </div>
                                           
                                    </div>
                                  
                                    </div>
                                </div>
                            </div>
                        <p className="text-muted_1"><img src={`${IMAGE_PATH}/calendar_today.png`}alt="calendar_today.png" style={{width: '15px',marginBottom: '2px' }}></img>Last Date: <span>{submittedDateFormatted}</span></p>
                        <div className='card_pera1'>
                        {
                            task.hasOwnProperty('descriptions') &&(task.descriptions.value) && (task.descriptions.value.length > 0)
                                ? task.descriptions.value.map((description, idx) => {
                                    // new description code 
                                    const words = description.split(" ");
                                    const shortText = words.slice(0, 50).join(" "); // First 100 words
                                    const isLong = words.length > 50; // Check if content is long

                                    // Split the description at the keyword "url"
                                    const parts = description.split('URL');

                                    if (parts.length > 1) {
                                    // Get the part after "url" and trim it
                                    let urlPart = parts[1].trim().replace(/[:\s]/g, '');

                                    // Check if the URL part starts with "http://" or "https://"
                                    if (!urlPart.includes('http')) {
                                        // If not, prepend "https://"
                                        urlPart = `https://${urlPart}`;
                                    }else{
                                        urlPart = urlPart.replace('https//', 'https://'); 
                                        urlPart = urlPart.replace('http//', 'https://');   
                                    }

                                    return (
                                        <p className="card_pera" key={idx} style={{textAlign:'justify'}}>
                                        {/* previous code */}
                                        {/*parts[0]*/} {/* Part before "url" */}
                                        {/* new code  */}
                                        {isLong && !isExpanded ? `${shortText}...` : parts[0]}
                                        {isLong && ( 
                                                    <a
                                                    onClick={() => setIsExpanded(!isExpanded)}
                                                    style={{
                                                    color: "blue",
                                                    cursor: "pointer",
                                                    display: "inline",
                                                    }}
                                                    >
                                                    {isExpanded ? "view less" : "view more"}
                                                    </a>
                                        )}
                                                <br />
                                        URL:
                                        <a href={urlPart} target="_blank" rel="noreferrer">{urlPart}</a> {/* Correctly formatted link */}
                                        </p>
                                    );
                                    } else{
                                         // If "url" is not found, render the description as plain text
                                    return (
                                        <p className="card_pera" style={{textAlign:'justify'}} key={idx}>
                                            {/* previous code */}
                                            {/* {description} */}
                                            {/* new code */}
                                                {isLong && !isExpanded ? `${shortText}...` : description}
                                                {isLong && ( 
                                                    <a
                                                    onClick={() => setIsExpanded(!isExpanded)}
                                                    style={{
                                                    color: "blue",
                                                    cursor: "pointer",
                                                    display: "inline",
                                                    }}
                                                    >
                                                    {isExpanded ? "view less" : "view more"}
                                                    </a>
                                                )}
                                        </p>
                                        );
                                    }
                                })
                                : ''
                            }


                        </div>
                        {/* Tags Section */}
                        <div className='row'>
                        <div className="tags col-12 col-md-8">
                            {
                            (task.hasOwnProperty('skills_and_expertise') &&(task.skills_and_expertise.value) && (task.skills_and_expertise.value.length > 0))?task.skills_and_expertise.value.map((skill, idx) => (
                                <span className="badge" key={`skill-${idx}`}>{skill}</span>
                            )):''
                            }  
                        </div>
                    {task.hasOwnProperty('assign_to')&& (task.assign_to.value) && (task.assign_to.value.filter(value => value && value.trim() !== "").length>0) && (
                        <div className='col-12 col-md-4 d-flex justify-content-start justify-content-md-end align-items-center ' style={{paddingRight:'20px'}} ref={dropdownRef}>
                        <div className='me-3 participant-headers'                                         
                            onClick={toggleDropDown}
                        >
                            Participants
                        </div>
                        {/* to show profile icon if dropdown is not open      */}
                        {!dropDown &&  (
                            <div className="position-relative " style={{ width: "72px", height: "24px" }}>
                                {task.assign_to.value
                                .filter(value => value && value.trim() !== "") 
                                .slice(0, 4).map((value, index) => {
                                const randomColor = getRandomColor();
                                const cleanedValue = value.replace(/\s*\([^)]*\)/g, "").trim();
                                 return   (
                                    <div className='participants-profile-icon' 
                                    key={index}
                                    onClick={toggleDropDown}
                                        style={{                    
                                            left: `${index * 20}px`, // Adjust the overlap distance (increase this to overlap more)
                                            zIndex:  index, // Adjust the zIndex to ensure the second image is above the first
                                            backgroundColor: randomColor
                                            }}
                                    >
                                    {cleanedValue && cleanedValue.split(" ").length>1 ?
                                    cleanedValue.split(" ")[0][0]?.toUpperCase() + cleanedValue.split(" ")[cleanedValue.split(" ").length-1][0]?.toUpperCase():
                                    cleanedValue.split(" ")[0][0]?.toUpperCase()}
                                    </div>
                                    )}
                                )}
                            </div>
                        )}
                        {/* to show close icon and dropdown if dropdown is open */}
                        {dropDown &&  (
                            <div >
                                <button type="button"                                          
                                    onClick={toggleDropDown}
                                    className='participants-close-button'
                                    >
                                    <img
                                    src={`${IMAGE_PATH}/close_icon.png`}
                                    alt="Profile Icon"
                                    className='participants-close-icon'
                                    />
                                        Close
                                </button>
                                <div className="dropdown" style={{ position: "relative" }}>
                                    <div className="dropdown-menu participants-custom-scrollbar participants-dropdown-container" 
                                    >
                                        {task.assign_to.value
                                        .filter(value => value && value.trim() !== "") 
                                        .map((value,index)=>{
                                            const randomColor = getRandomColor();
                                            const cleanedValue = value.replace(/\s*\([^)]*\)/g, "").trim();
                                            return (  
                                                <div className="dropdown-item d-flex " 
                                                key={index}>
                                                    <div className='participants-dropdown-image'
                                                    style={{backgroundColor:randomColor}}
                                                    >
                                                    {cleanedValue && cleanedValue.split(" ").length>1 ?
                                                    cleanedValue.split(" ")[0][0]?.toUpperCase() + cleanedValue.split(" ")[cleanedValue.split(" ").length-1][0]?.toUpperCase():
                                                    cleanedValue.split(" ")[0][0]?.toUpperCase()}
                                                    </div>
                                                    <div 
                                                    className='participants-dropdown-text'
                                                    title={cleanedValue} // Add this to show full value on hover
                                                    >  
                                                    {cleanedValue}
                                                    </div>
                                                </div>      
                                            )
                                        })                          
                                        }
                                    </div>
                                </div>
                            </div>
                        )}
                        </div> 
                    )}                           
                        </div>
                        
                        </div>
                        <div className="row align-items-center pdf-btns pdf-mob">
 
                          <div className={`${allowedArtifactIds.includes(task.artifact_id) ? 'col-md-3' : 'col-md-4'} col-12 d-flex align-items-center`} onClick={handleUserClick}>
                           <div className="icon-circle me-3">
                           <img src={`${IMAGE_PATH}/user_manual_v1.png`} alt="user_manual_v1.png"/>
                             <i className="bi bi-file-earmark-arrow-down"></i>
                                </div>

   
                               <span className="contributor-text-desktop contributor-text-mobiles ">User Manual for Contributor</span>

  
                                <span className="contributor-text-mobile ">User Manual for Contributor</span>
                                     </div>


                              {/* <div className="col-md-1 d-none d-md-block">
                                   <div className="divider"></div>
                                   </div> */}


                                    <div className={`${allowedArtifactIds.includes(task.artifact_id) ? 'col-md-3' : 'col-md-5'} col-12 d-flex align-items-center mt-3 mt-md-0`} onClick={handleImageClick}>
                                  <div className="icon-circle me-3">
                                 <img src={`${IMAGE_PATH}/user_manual_v1.png`} alt="user_manual_v1.png"/>
                              <i className="bi bi-file-earmark-arrow-down"></i>
                                    </div>

   
                                  <span className="sop-text-desktop contributor-text-mobiles  ">Standard Operating Procedure (SOP)</span>

   
                              <span className="sop-text-mobile " >Standard Operating Procedure (SOP)</span>
                                  </div>
                       {allowedArtifactIds.includes(task.artifact_id) && (

                            <div className="col-md-3 col-12 d-flex align-items-center excel-download-icon" onClick={handleExcelClick}>
                                <div className="icon-circle me-3">
                                <img src={`${IMAGE_PATH}/user_manual_v1.png`} alt="user_manual_v1.png"/>
                                <i className="bi bi-file-earmark-arrow-down"></i>
                                </div>
                               <span className="contributor-text-desktop contributor-text-mobiles ">GIGW 3.0 Web Accessibility</span>
                                <span className="contributor-text-mobile ">GIGW 3.0 Web Accessibility</span>
                            </div>
                        )}

                                  <div className="col-md-3 col-12 mt-3 mt-md-0">
                                    {/* Previous code */}
                                    <Link to={`/collabwithgov/detail/${task.artifact_id}`} 
                                    className="detail_btn1 btn btn-outline-success  
                                    "style={{borderRadius: '20px',float: 'right',marginRight: '10px', fontSize: '14px',marginTop: '-4px', color:'#105B38'}}>View Details</Link>
                                    {/* newcode useNavigate */}
                                    {/* <button
                                     className="detail_btn1 btn btn-outline-success"
                                     style={{borderRadius: '20px',float: 'right',marginRight: '10px', fontSize: '14px',marginTop: '-4px'}}
                                     onClick={handleNavigation}         
                                     >View Details</button>          */}
                                  </div>
                        </div>
                    </div>
                </div>
            </div>
           
        </>
    )
}